import React, { FC, ReactNode } from 'react';

import { StyledBlock, StyledRipple } from './styled';

/** Passed to `MainMenuItemWrapper` when a community row is non-interactive as a link. */
export type MainMenuItemDisableReason =
  | 'none'
  | 'blocked'
  | 'subscriptionSlotInactive'
  | 'subscriptionInactive';

interface MainMenuItemWrapperProps {
  children: ReactNode;
  to: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  /** When `isDisabled` is true, controls ring/badge styling. */
  disableReason?: MainMenuItemDisableReason;
  'aria-label'?: string;
}

const MainMenuItemWrapper: FC<MainMenuItemWrapperProps> = ({
  children,
  to,
  isDisabled = false,
  isSelected,
  disableReason = 'none',
  'aria-label': ariaLabel,
}) => (
  <StyledBlock
    to={to}
    $isDisabled={isDisabled}
    $isSelected={isSelected}
    $disableReason={disableReason}
    aria-label={ariaLabel}
  >
    {isSelected && !isDisabled ? <StyledRipple aria-hidden /> : null}
    {children}
  </StyledBlock>
);

export default MainMenuItemWrapper;
